import React, { useState, useEffect } from 'react'
import Loader from '../../../../../../presentationals/Loader/Loader.component';
import PiePage from '../../../CommonComponents/PiePage.component'
import InputField from '../../../CommonComponents/InputMUI'
import SelectField from '../../../CommonComponents/SelectMUI';
import { SaveUpdateOEMBatteryDetails } from '../../../Community/CommunityActionCreator';
import { Edit } from '@mui/icons-material';

const DifferenceInYear = 40;

const getYearValues = () => {
    const arr = [];
    const d = new Date();
    const currentYear = d.getFullYear();
    const PrevYear = currentYear - DifferenceInYear;


    for (let i = PrevYear; i <= currentYear; i++) {
        let obj = { name: i, code: i };
        arr.push(obj)
    }
    return arr

}

export default function OEMAddEdit({ handlePage,handleTab, Editdata }) {
    const [loader, setLoader] = useState(false)
    const [responseMsg, setResponseMsg] = useState("")
    const [yearData, setYearData] = useState(getYearValues())
    const [errors, setErrors] = useState({});
    const [objectDataNew, setobjectDataNew] = useState({
        oemName: "",
        weightage: "",
       
    })

    useEffect(() => {
        if (Editdata?.id || Editdata?.batteryOemId) {
            setobjectDataNew({
                oemName: Editdata?.oemName || "",
                weightage: Editdata?.weightage || "",
            })
        } else {
            setobjectDataNew({
                oemName: "",
                weightage: "",
            })
        }
    }, [Editdata])

    const inputChange = (e, type) => {
        setobjectDataNew((prev) => ({
            ...prev,
            [type]: e
        }))
    }

    const validateForm = () => {
        let formErrors = {};
        let isValid = true;

        if (!objectDataNew.model) {
            formErrors.model = "Model is required";
            isValid = false;
        }

        if (!objectDataNew.make) {
            formErrors.make = "Vehicle Make is required";
            isValid = false;
        }
        if (!objectDataNew.makeClass) {
            formErrors.makeClass = "Vehicle Make Class is required";
            isValid = false;
        }
        if (!objectDataNew.vehicleType) {
            formErrors.vehicleType = "Vehicle Type is required";
            isValid = false;
        }
        if (!objectDataNew.variant) {
            formErrors.variant = "Vehicle Variant is required";
            isValid = false;
        }
        if (!objectDataNew.year) {
            formErrors.year = "Year is required";
            isValid = false;
        }

        setErrors(formErrors);
        return isValid;
    };

    const saveHandler = (type) => {
        if (type === "close") {
            setobjectDataNew({
                oemName:  "",
                weightage:  "",
            })
            handleTab("list", "")
        } else {
            // if (validateForm()) {
            const obj = objectDataNew;
            if(Editdata?.id || Editdata?.batteryOemId){
                obj.id = Editdata?.id;
                obj.batteryOemId = Editdata?.batteryOemId;
                obj.addedOn = Editdata?.addedOn;
            }
                setLoader(true)
                SaveUpdateOEMBatteryDetails(obj, (callback) => {
                    setLoader(false)
                    console.log("call", callback)
                    if(callback && callback?.message == "success" && callback?.status == 200){
                        // handlePage("OEMBre", objectDataNew)
                        handleTab("list", "")
                    }else{
                        setResponseMsg("Error: Please try again later!")
                    }
                })
             
            // }
            // RemoveErrors()
        }
    }

    const RemoveErrors = ()=>{
        setTimeout(()=>{
            setErrors({})
        },3000)
    }

    return (
        <div className="communitySection">
            <div className='container hoverNone card'>
                {loader ?
                    <Loader />
                    : null}


                <PiePage
                    totalPage={1}
                    currentPage={1}
                    heading={'Add Battery OEM Details'}
                />

                <div className='row' style={{ marginBottom: '12px' }}>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Battery OEM Name"
                            variant="outlined"
                            value={objectDataNew.oemName}
                            name="oemName"
                            id="oemName"
                            type="text"
                            onChange={e => inputChange(e, 'oemName')}
                            size="small"

                        />

                        {errors.oemName && (
                            <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.oemName}</span>
                        )}

                    
                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Weightage"
                            variant="outlined"
                            value={objectDataNew.weightage}
                            name="weightage"
                            id="weightage"
                            type="number"
                            onChange={e => inputChange(e, 'weightage')}
                            size="small"



                        />
                        {errors.Weightage && (
                            <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.Weightage}</span>
                        )}

                    </div>

                   
                </div>
              

                <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                    <div className="form-text text-danger">{responseMsg}</div>
                    <div className="col-12 text-center">

                        <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>
                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
